import { BrowserRouter, Outlet, Route, Routes } from "react-router-dom";

import Login from "./screens/login/Login";
import { RequireAuth, useCurrentUser, useTokenRestore } from "melco-shared-logic";
import { Dashboard } from "./screens/dashboard/Dashboard";
import ServiceTermModal from "./components/serviceterms/ServiceTermModal";
import { ErrorBoundary } from "react-error-boundary";
import { ApplicationErrorBoundary } from "./components/errorboundary/ApplicationErrorBoundary";
import { MyRolesContext } from "./hooks/roles/useRolesContext";
import { useAppRoles } from "./hooks/roles/useAppRoles";
import { Users } from "./screens/users/Users";
import { UserDetails } from "./screens/users/UserDetails";
import { Licenses } from "./screens/licenses/Licenses";
import { LicenseDetails } from "./screens/licenses/LicenseDetails";
import LicenseManager from "./screens/licensemanager/LicenseManager";
import { UrlForward } from "./screens/urlforward/UrlForward";
import { Downloads } from "./screens/downloads/Downloads";
import { ReportsDownloadBilling } from "./screens/reports/ReportsDownloadBilling";
import { EmailHistory } from "./screens/emailhistory/EmailHistory";
import { Products } from "./screens/products/Products";
import { LocaleStrings } from "./screens/localestrings/LocaleStrings";
import { ManageSuppliers } from "./screens/supplier/ManageSuppliers";
import { ManageSupplierProducts } from "./screens/supplierproducts/ManageSupplierProducts";
import { Error404 } from "./screens/404/Error404";
import MelcoControlCenterApplicationLayout from "./components/layout/MelcoControlCenterApplicationLayout";
import { ManageHoops } from "./screens/hoops/ManageHoops";
import { Logs } from "./screens/logs/Logs";
import { MachineLicenses } from "./screens/licenses/MachineLicenses";
// import { SummitDetails } from "./screens/summit/SummitDetails";
import { ManageThreads } from "./screens/threads/ManageThreads";
import { UpdateHoop } from "./screens/hoops/UpdateHoop";
import { UpdateThread } from "./screens/threads/UpdateThread";
import { Summit } from "./screens/summit/Summit";

function ErrorFallback() {
  return <ApplicationErrorBoundary />;
}

export const MainBerninaLogin: React.FC = () => {
  const tokenRestoreState = useTokenRestore({
    skipRedirectOnStartupError: true,
    skipTermsHandlingOnStartup: true,
  });

  //useSetApplicationLanguage();

  const currentUser = useCurrentUser();
  //  console.log(JSON.stringify(currentUser))
  const { roles } = useAppRoles(currentUser?.permissions ?? []);
  const PRODUCT_CODE = process.env.REACT_APP_PRODUCT_CODE!;
  return (
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      {/* <MyAppSettingsContext.Provider value={{ appSettingsResponse }} > */}

      <MyRolesContext.Provider value={{ roles }}>
        <BrowserRouter>
          <Routes>

            <Route
              path="dashboard"
              element={
                <RequireAuth tokenRestoreState={tokenRestoreState}>
                  <MelcoControlCenterApplicationLayout>
                    <Dashboard />
                  </MelcoControlCenterApplicationLayout>


                </RequireAuth>
              }
            >
              <Route path="" />
              <Route path="terms/:productCode" element={<ServiceTermModal productCode={PRODUCT_CODE} />} />
            </Route>


            <Route
              path="users"
              element={
                <RequireAuth tokenRestoreState={tokenRestoreState}>
                  <MelcoControlCenterApplicationLayout>
                    <Outlet />
                  </MelcoControlCenterApplicationLayout>
                </RequireAuth>
              }>
              <Route path="" element={<Users />} />
              <Route path=":userId" element={<UserDetails />} />
            </Route>

            <Route
              path="licenses"
              element={
                <RequireAuth tokenRestoreState={tokenRestoreState}>
                  <MelcoControlCenterApplicationLayout>
                    <Outlet />
                  </MelcoControlCenterApplicationLayout>
                </RequireAuth>
              }
            >

              {/* <Route path="" element={<Licenses />} />
              <Route path=":licenseId" element={<LicenseDetails />} /> */}
              <Route path="softwarelicenses" element={<Licenses />} />
              <Route path="softwarelicenses/:licenseId" element={<LicenseDetails />} />
              <Route path="machinelicenses" element={<MachineLicenses />} />
            </Route>


            <Route
              path="licensemanager"
              element={
                <RequireAuth tokenRestoreState={tokenRestoreState}>
                  <MelcoControlCenterApplicationLayout>
                    <Outlet />
                  </MelcoControlCenterApplicationLayout>
                </RequireAuth>
              }
            >
              <Route path="" element={<LicenseManager />} />
            </Route>

            <Route
              path="urlforward"
              element={
                <RequireAuth tokenRestoreState={tokenRestoreState}>
                  <MelcoControlCenterApplicationLayout>
                    <Outlet />
                  </MelcoControlCenterApplicationLayout>
                </RequireAuth>
              }
            >
              <Route path="" element={<UrlForward />} />

            </Route>
            <Route
              path="downloads"
              element={
                <RequireAuth tokenRestoreState={tokenRestoreState}>
                  <MelcoControlCenterApplicationLayout>
                    <Outlet />
                  </MelcoControlCenterApplicationLayout>
                </RequireAuth>
              }
            >
              <Route path="" element={<Downloads />} />
            </Route>

            <Route path="reports">
              <Route
                path=""
                element={
                  <RequireAuth tokenRestoreState={tokenRestoreState}>
                    <MelcoControlCenterApplicationLayout>
                      <Outlet />
                    </MelcoControlCenterApplicationLayout>
                  </RequireAuth>
                } />

              {/* <Route path="licenses" element={<Licenses />} />  */}
              {/* <Route path="urlforward" element={<UrlForward />} />  */}
              <Route path="downloadsbilling" element={<ReportsDownloadBilling />} />
            </Route>

            <Route
              path="analytics"
              element={
                <RequireAuth tokenRestoreState={tokenRestoreState}>
                  <MelcoControlCenterApplicationLayout>
                    <Outlet />
                  </MelcoControlCenterApplicationLayout>
                </RequireAuth>
              }>
              <Route path="" />
              <Route path="emails" element={<EmailHistory />} />
            </Route>

            <Route
              path="system"
              element={
                <RequireAuth tokenRestoreState={tokenRestoreState}>
                  <MelcoControlCenterApplicationLayout>
                    <Outlet />
                  </MelcoControlCenterApplicationLayout>
                </RequireAuth>
              }>
              <Route path="" />

              {/* <Route path="licenses" element={<Licenses />} />  */}
              {/* <Route path="urlforward" element={<UrlForward />} />  */}

              <Route path="products" element={<Products />} />
              <Route path="locale" element={<LocaleStrings />} />
              <Route path="managehoops" element={<ManageHoops />} />

              <Route path="managethreads" element={<ManageThreads />} />
              <Route path="managesupplier" element={<ManageSuppliers />} />
              <Route path="managesupplierproducts" element={<ManageSupplierProducts />} />
              <Route path="managehoops/:hoopId" element={<UpdateHoop />} />
              <Route path="managethreads/:threadId" element={<UpdateThread />} />

            </Route>
            <Route
              path="tools"
              element={
                <RequireAuth tokenRestoreState={tokenRestoreState}>
                  <MelcoControlCenterApplicationLayout>
                    <Outlet />
                  </MelcoControlCenterApplicationLayout>
                </RequireAuth>
              }>
              <Route path="" />
              <Route path="logs" element={<Logs />} />
              <Route path="summit" element={<Summit />} />
            </Route>


            <Route path="login" element={<Login />} />
            <Route path="" element={<Login />} />
            {/* <Route path="*" element={<Login />} /> */}
            <Route element={<Error404 />} />

          </Routes >
        </BrowserRouter >
      </MyRolesContext.Provider >
      {/* </MyAppSettingsContext.Provider> */}
    </ErrorBoundary >
  );
};
